import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { AppEndpointKeys } from '../../utils/constants/AppEndpoint';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.APP_MSAL_CLIENT_ID,
    authority: AppEndpointKeys.MSAL,
    redirectUri: AppEndpointKeys.MSAL_POST_LOGIN,
    postLogoutRedirectUri: AppEndpointKeys.MSAL_POST_LOGOUT,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    secureCookies: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 1 * 60,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
